import { Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'app-transport-scope-icon',
    templateUrl: './transport-scope-icon.component.html',
    styleUrls: ['./transport-scope-icon.component.scss'],
    standalone: false
})
export class TransportScopeIconComponent {

  @Input() warning: boolean;

  scopeClass = 'train-scope';

  fahrzeug = false;

  @Input() set scope(value: string) {

    switch (value) {
      case 'TRAILER': this.scopeClass = 'trailer-scope'; break;
      case 'SWAP_TRAILER': this.scopeClass = 'swap-trailer-scope'; break;
      case 'SEMI_TRAILER_TRUCK': this.scopeClass = 'semi-trailer-truck-scope'; break;
      default: this.scopeClass = 'train-scope';
    }
  }

  @Input() set type(value: string) {
    this.fahrzeug = 'VEHICLE' === value;
  }

}
